import {checarGrupo, checarFuncao} from './helpers'
import { TIPOS_RELATORIO } from './tipos-relatorio'

export const GRUPOS_RELATORIO = {
  habilitarFiltroData: [
    TIPOS_RELATORIO.entradas,
    TIPOS_RELATORIO.saidas
  ],
  leilao: [],
  habilitarFiltroPatio: [
    TIPOS_RELATORIO.estoque,
    TIPOS_RELATORIO.trasnferidosPatioCentral,
    TIPOS_RELATORIO.entradas,
    TIPOS_RELATORIO.saidas
  ],
  checarGrupo
}

export const MENU = {
  'Administração': [
    {
      label: 'Estoque',
      value: TIPOS_RELATORIO.estoque,
      selected: true,
      disabled: false
    },
    {
      label: 'Entradas',
      value: TIPOS_RELATORIO.entradas,
      selected: false,
      disabled: false
    },
    {
      label: 'Saídas',
      value: TIPOS_RELATORIO.saidas,
      selected: false,
      disabled: false
    },
    {
      label: 'Transferido ao Pátio Central',
      value: TIPOS_RELATORIO.trasnferidosPatioCentral,
      selected: false,
      disabled: false
    },
    {
      label: 'Bloqueados para leilão',
      value: TIPOS_RELATORIO.bloqueadosParaLeilao,
      selected: false,
      disabled: false
    }
  ]
}

export const FUNCTIONS = {
  [TIPOS_RELATORIO.estoque]: 'gerarRelatorioEstoque',
  [TIPOS_RELATORIO.entradas]: 'gerarRelatorioEntradas',
  [TIPOS_RELATORIO.saidas]: 'gerarRelatorioSaidas',
  [TIPOS_RELATORIO.trasnferidosPatioCentral]: 'gerarRelatorioTransferidosPatioCentral',
  [TIPOS_RELATORIO.bloqueadosParaLeilao]: 'gerarRelatorioBloqueadosParaLeilao',
  checarFuncao
}

export default {TIPOS_RELATORIO, GRUPOS_RELATORIO, MENU, FUNCTIONS}



// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/config-tipos-relatorio/detranES.js